module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NCIgaGVpZ2h0PSI1NCIgdmlld0JveD0iMCAwIDU0IDU0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgc3Ryb2tlPSIjNEE5MEUyIiBzdHJva2Utd2lkdGg9IjQiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTkyLjM3NiAyODUuMjczQzE4OC43MjYgMjgzLjE5IDE4NC41MDIgMjgyIDE4MCAyODJjLTEzLjgwNyAwLTI1IDExLjE5My0yNSAyNXMxMS4xOTMgMjUgMjUgMjUgMjUtMTEuMTkzIDI1LTI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUzIC0yODApIHJvdGF0ZSgtMTcwIDE4MCAzMDcpIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding/spinner-big.svg
// module id = +Us7
// module chunks = 6